(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ga-blog-essentiel"] && !Shopify.designMode) return;
  try {
    
function setupGuideAchatBlog(){document.querySelectorAll('.ga-blog').forEach(root=>{if(root.dataset.gaReady)return;root.dataset.gaReady='true';const sticky=root.querySelector('.ga-sticky');const winner=root.querySelector('.ga-winner');const update=()=>{if(sticky&&winner)sticky.classList.toggle('ga-visible',winner.getBoundingClientRect().bottom<0)};window.addEventListener('scroll',update,{passive:true});update()})}setupGuideAchatBlog();document.addEventListener('shopify:section:load',setupGuideAchatBlog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-chauffages-purivo"] && !Shopify.designMode) return;
  try {
    
function setupBBRComparatorV2(){
const root=document.getElementById('bbr-uk-v2');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const toggle=root.querySelector('[aria-controls="bbr-v2-mobile-nav"]');if(toggle)toggle.addEventListener('click',()=>{let menu=root.querySelector('#bbr-v2-mobile-nav');if(!menu){menu=document.createElement('nav');menu.id='bbr-v2-mobile-nav';const nav=root.querySelector('nav[aria-label="Main"]');if(nav)menu.innerHTML=nav.innerHTML;root.querySelector('header').append(menu);}const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));menu.hidden=expanded;});
const bar=root.querySelector('.tc-sticky');if(bar){let pending=false;const update=()=>{const show=window.scrollY>800;bar.classList.toggle('translate-y-full',!show);bar.setAttribute('aria-hidden',String(!show));bar.querySelectorAll('a').forEach(a=>a.tabIndex=show?0:-1);pending=false;};window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});update();}
}
setupBBRComparatorV2();document.addEventListener('shopify:section:load',setupBBRComparatorV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-lave-vitres-essentiel"] && !Shopify.designMode) return;
  try {
    
function setupGuideAchatBlog(){document.querySelectorAll('.ga-blog').forEach(root=>{if(root.dataset.gaReady)return;root.dataset.gaReady='true';const sticky=root.querySelector('.ga-sticky');const winner=root.querySelector('.ga-winner');const update=()=>{if(sticky&&winner)sticky.classList.toggle('ga-visible',winner.getBoundingClientRect().bottom<0)};window.addEventListener('scroll',update,{passive:true});update()})}setupGuideAchatBlog();document.addEventListener('shopify:section:load',setupGuideAchatBlog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-projecteurs-bbr"] && !Shopify.designMode) return;
  try {
    
function setupBBRComparatorV2(){
const root=document.getElementById('bbr-uk-v2');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const toggle=root.querySelector('[aria-controls="bbr-v2-mobile-nav"]');if(toggle)toggle.addEventListener('click',()=>{let menu=root.querySelector('#bbr-v2-mobile-nav');if(!menu){menu=document.createElement('nav');menu.id='bbr-v2-mobile-nav';const nav=root.querySelector('nav[aria-label="Main"]');if(nav)menu.innerHTML=nav.innerHTML;root.querySelector('header').append(menu);}const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));menu.hidden=expanded;});
const bar=root.querySelector('.tc-sticky');if(bar){let pending=false;const update=()=>{const show=window.scrollY>800;bar.classList.toggle('translate-y-full',!show);bar.setAttribute('aria-hidden',String(!show));bar.querySelectorAll('a').forEach(a=>a.tabIndex=show?0:-1);pending=false;};window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});update();}
}
setupBBRComparatorV2();document.addEventListener('shopify:section:load',setupBBRComparatorV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-souffleurs-2026"] && !Shopify.designMode) return;
  try {
    
function setupBBRComparatorV2(){
const root=document.getElementById('bbr-uk-v2');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const toggle=root.querySelector('[aria-controls="bbr-v2-mobile-nav"]');if(toggle)toggle.addEventListener('click',()=>{let menu=root.querySelector('#bbr-v2-mobile-nav');if(!menu){menu=document.createElement('nav');menu.id='bbr-v2-mobile-nav';const nav=root.querySelector('nav[aria-label="Main"]');if(nav)menu.innerHTML=nav.innerHTML;root.querySelector('header').append(menu);}const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));menu.hidden=expanded;});
const bar=root.querySelector('.tc-sticky');if(bar){let pending=false;const update=()=>{const show=window.scrollY>800;bar.classList.toggle('translate-y-full',!show);bar.setAttribute('aria-hidden',String(!show));bar.querySelectorAll('a').forEach(a=>a.tabIndex=show?0:-1);pending=false;};window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});update();}
}
setupBBRComparatorV2();document.addEventListener('shopify:section:load',setupBBRComparatorV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
